import React from 'react';
import { Row, Col } from 'react-styled-flexboxgrid';
import PropTypes from 'prop-types';
import { Line } from '@vds/lines';
import { Title, Body } from '@vds/typography';

import { Margin } from '../../../common/styles';
import { isMobile } from '../../../common/Helpers/useragent';
import { Content1, Content2, Graph, GraphDetailsSpan, VisuallyHiddenSpan } from './NBS.styles';
import { convertDate } from '../NextBillsUtils';

import { nbsLabels } from '../labels';

const NBSGraph = (props) => {
  const nbsVo = props.data || {};

  const { invoiceTwoMonthPrevious, invoiceLastMonth, invoiceLastMonthCycleEnddate, invoiceTwoMonthCycleEnddate } = nbsVo?.barGraphDetails || {};
  const { nextMonthGrandTotal, thisMonthGrandTotal } = nbsVo?.monthlyTotalsInfo || {};

  const showvalue = invoiceTwoMonthPrevious || invoiceLastMonth || nextMonthGrandTotal || thisMonthGrandTotal > 600 ? 6.7 : 3.7;
  const barGraphFlag = nbsVo && nbsVo?.barGraphDetails && nbsVo?.barGraphDetails;

  if (barGraphFlag === undefined || barGraphFlag === null) {
    return false;
  }

  return (
    <>
      {barGraphFlag && (
        <div>
          <Margin top="20px">
            <Line type="primary" />
            <Margin top="8px">
              <Title size="medium" id="caption_id" primitive="h3" bold>
                What to expect
              </Title>
            </Margin>
          </Margin>
          <Margin bottom="45px">
            <Graph aria-labelledby="caption_id">
              <thead>
                <tr>
                  <th scope="col">Bill</th>
                  <th scope="col">Month</th>
                </tr>
              </thead>

              <tbody>
                {invoiceTwoMonthCycleEnddate ? (
                  <tr
                    style={{
                      height: `${invoiceTwoMonthPrevious / showvalue}px`,
                      backgroundColor: '#E4E5E3',
                    }}
                    className="bar1"
                  >
                    <th scope="row">
                      <Body size="large" primitive="p" bold>
                        <VisuallyHiddenSpan>Actual monthly charges</VisuallyHiddenSpan>
                        {invoiceTwoMonthPrevious !== undefined ? `$${invoiceTwoMonthPrevious}` : ''}
                      </Body>
                    </th>
                    <td>
                      <div aria-label={`Actual monthly charges ${convertDate(invoiceTwoMonthCycleEnddate)}`}>
                        <Body size="small" tabIndex={-1} primitive="p" bold>
                          {convertDate(invoiceTwoMonthCycleEnddate)}
                        </Body>
                      </div>
                    </td>
                  </tr>
                ) : (
                  <tr />
                )}
                {invoiceLastMonthCycleEnddate ? (
                  <tr
                    style={{
                      height: `${invoiceLastMonth / showvalue}px`,
                      backgroundColor: '#E4E5E3',
                    }}
                    className="bar1"
                  >
                    <th scope="row">
                      <Body size="large" primitive="p" bold>
                        <VisuallyHiddenSpan>Actual monthly charges</VisuallyHiddenSpan>
                        {invoiceLastMonth !== undefined ? `$${invoiceLastMonth}` : ''}
                      </Body>
                    </th>
                    <td>
                      <div aria-label={`Actual monthly charges ${convertDate(invoiceLastMonthCycleEnddate)}`}>
                        <Body size="small" tabIndex={-1} primitive="p" bold>
                          {convertDate(invoiceLastMonthCycleEnddate)}
                        </Body>
                      </div>
                    </td>
                  </tr>
                ) : (
                  <tr />
                )}
                <tr
                  style={{
                    height: `${nextMonthGrandTotal / showvalue}px`,
                    backgroundColor: '#FFBC3D',
                  }}
                  className="bar2"
                >
                  <th scope="row">
                    <Body size="large" primitive="p" bold>
                      <VisuallyHiddenSpan>Estimated monthly charges</VisuallyHiddenSpan>
                      {`$${nextMonthGrandTotal}`}
                    </Body>
                  </th>
                  <td>
                    <div aria-label="Estimated monthly charges Next bill">
                      <Body size="small" tabIndex={-1} primitive="p" bold>
                        Next bill
                      </Body>
                    </div>
                  </td>
                </tr>
                <tr
                  style={{
                    height: `${thisMonthGrandTotal / showvalue}px`,
                    backgroundColor: '#FFBC3D',
                  }}
                  className="bar2"
                >
                  <th scope="row">
                    <Body size="large" primitive="p" bold>
                      <VisuallyHiddenSpan>Estimated monthly charges</VisuallyHiddenSpan>
                      {`$${thisMonthGrandTotal}`}
                    </Body>
                  </th>
                  <td>
                    <div aria-label="Estimated monthly charges New monthly">
                      <Body size="small" tabIndex={-1} primitive="p" bold>
                        New monthly
                      </Body>
                    </div>
                  </td>
                </tr>
              </tbody>
            </Graph>
          </Margin>

          <Row>
            <Col xs={4} sm={4} md={4} lg={4}>
              <Body size="small" viewport={isMobile() ? 'mobile' : 'desktop'} primitive="p">
                <Content1 style={{ display: 'inline-block' }} />
                <GraphDetailsSpan>Actual monthly charges</GraphDetailsSpan>
              </Body>
            </Col>
            <Col xs={4} sm={4} md={4} lg={4}>
              <Body size="small" viewport={isMobile() ? 'mobile' : 'desktop'} primitive="p">
                <Content2 style={{ display: 'inline-block', marginLeft: '40px' }} />
                <GraphDetailsSpan>Estimated monthly charges</GraphDetailsSpan>
              </Body>
            </Col>
            <Col xs={4} sm={4} md={4} lg={4}>
              &nbsp;
            </Col>
          </Row>

          <Margin top="18px">
            <Row>
              <Col xs={12}>
                <Body size="small" primitive="p">
                  {nbsLabels.disclaimerNextBill}
                </Body>
              </Col>
            </Row>
          </Margin>
          <Margin top="18px">
            <Row>
              <Col xs={12}>
                <Body size="small" primitive="p">
                  {nbsLabels.disclaimerActualBill}
                </Body>
              </Col>
            </Row>
          </Margin>
        </div>
      )}
    </>
  );
};

NBSGraph.propTypes = {
  data: PropTypes.object,
};

export default React.memo(NBSGraph);
